module.exports = __webpack_public_path__ + "563bc797bc6a078ebb27836d0b882d4a.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/nav_title.svg
 ** module id = 265
 ** module chunks = 0
 **/